import { useEffect, useRef, useState } from "react";
import { t } from "i18next";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
import { cn } from "@/lib/utils";

import useMapStore from "@/store/mapStore";
import useIsOverflow from "@/hooks/useIsOverflow";

const defaultDetails = "";

function PoiDetailsDescription({ showMore }: { showMore: boolean }) {
  const [details, setDetails] = useState(defaultDetails);
  const [toggleDetails, setToggleDetails] = useState(false);
  let poi = useMapStore((state) => state.routeFinish);
  const textRef = useRef<HTMLDivElement>(null);
  const isOverflow = useIsOverflow(textRef, [details]);
  const activeStop = useMapStore((state) => state.activeStop);
  const stops = useMapStore((state) => state.stops);

  const currentLanguage = useMapStore((state) => state.currentLang);
  const mobileMode = useMapStore((state) => state.mobileMode);

  if (stops.length > 2 && stops[activeStop]?.feature) {
    poi = stops[activeStop].feature!;
  }

  useEffect(() => {
    setToggleDetails(false);
    if (poi?.properties?.description_i18n) {
      setDetails(
        poi.properties.description_i18n[currentLanguage]
          ? poi.properties.description_i18n[currentLanguage]
          : poi.properties.description_i18n.en,
      );
      return;
    }
    if (poi?.properties?.metadata?.description) {
      setDetails(
        poi.properties.metadata.description[currentLanguage]
          ? poi.properties.metadata.description[currentLanguage]
          : poi.properties.metadata.description.en,
      );
      return;
    }
    setDetails(defaultDetails);
  }, [
    poi?.properties?.description_i18n,
    poi?.properties?.metadata?.description,
    currentLanguage,
  ]);

  return (
    <>
      {details && (
        <div
          className={cn("mt-4 lg:mb-4 lg:mt-0 lg:block", !showMore && "hidden")}
        >
          <p
            ref={textRef}
            className={cn(
              "text-ellipsis text-sm lg:text-base",
              !toggleDetails && !mobileMode && "line-clamp-3",
            )}
          >
            {details}
          </p>
          {isOverflow && !mobileMode && !toggleDetails && (
            <span
              onClick={() => {
                setToggleDetails(true);
              }}
              className="mt-4 inline-block cursor-pointer text-xs font-semibold text-primary hover:text-primary/70"
            >
              <FaAngleDown className="inline-flex h-6 w-6 rounded-full bg-primary px-1 pt-[2px] text-lg text-white group-data-[dir=ltr]:mr-2 group-data-[dir=rtl]:ml-2" />
              {t("showMore")}
            </span>
          )}
          {isOverflow && toggleDetails && (
            <span
              onClick={() => {
                setToggleDetails(false);
              }}
              className="mt-4 inline-block cursor-pointer text-xs font-semibold text-primary hover:text-primary/70"
            >
              <FaAngleUp className="inline-flex h-6 w-6 rounded-full bg-primary px-1 pt-0 text-lg text-white group-data-[dir=ltr]:mr-2 group-data-[dir=rtl]:ml-2" />
              {t("showLess")}
            </span>
          )}
        </div>
      )}
    </>
  );
}

export default PoiDetailsDescription;
